import { reactive, ref } from 'vue';

import FormInputComponent from '@/components/_shared/_partials/form-input/form-input.vue';

export default {
  name: 'PaymentListComponent',
  components: { FormInputComponent },
  props: {
    profiles: {
      type: Array,
      required: false
    },
    defaultProfile: {
      type: Number,
      required: false,
      default: null
    },
    selectedProfile: {
      type: Number,
      required: false,
      default: null
    },
    showActivationOptions: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  setup() {
    const state = reactive({
      isEditing: ref(null),
      first_name: null,
      last_name: null,
      billing_address: null,
      billing_address_2: null,
      billing_city: null,
      billing_state: null,
      billing_zip: null,
      billing_country: null,
      update: async (data) => {
        const { key, value } = data;
        state[key] = value;
      },
    });

    const isDefault = function(payment, defaultProfile, selectedProfile) {
      return payment.id === defaultProfile;
    };

    const isSelected = function(payment, selectedProfile) {
      return payment.id === selectedProfile;
    };

    return { state, isSelected, isDefault };
  },
  methods: {
    activate: async function(payment) {
      this.$emit('activate', payment);
    },
    remove: async function(payment, isDefault, isSelected) {
      this.$emit('remove', payment, isDefault, isSelected);
    },
    updatePayment: async function(state) {
      const id = state.isEditing.id;
      const first_name = state.first_name || state.isEditing.details.name.first;
      const last_name = state.last_name || state.isEditing.details.name.last;
      const billing_address = state.billing_address || state.isEditing.billing.address;
      const billing_address_2 = state.billing_address_2 || state.isEditing.billing.address_2;
      const billing_city = state.billing_city || state.isEditing.billing.city;
      const billing_state = state.billing_state || state.isEditing.billing.state;
      const billing_zip = state.billing_zip || state.isEditing.billing.zip;
      const billing_country = state.billing_country || state.isEditing.billing.country;

      this.$emit('update', {
        id,
        first_name,
        last_name,
        billing_address,
        billing_address_2,
        billing_city,
        billing_state,
        billing_zip,
        billing_country,
      });

      state.isEditing = null;
      state.first_name = null;
      state.last_name = null;
      state.billing_address = null;
      state.billing_address_2 = null;
      state.billing_city = null;
      state.billing_state = null;
      state.billing_zip = null;
      state.billing_country = null;
    }
  }
};
